import BucketApiRequest from "./BucketApiRequest";
import { TERMS_BUCKET_URL } from "../ApiUrls";

export default class TermsJsonRequest extends BucketApiRequest {
  getUrl = () => {
    return TERMS_BUCKET_URL;
  };
}
